import { Grid, Stack, Typography } from "@mui/material";

import { FormikAutocomplete } from "@/common/components/fields/formik/formik-autocomplete/FormikAutocomplete";
import { FormikDatePicker } from "@/common/components/fields/formik/formik-date-picker/FormikDatePicker";
import { useDropdownOptions } from "@/common/hooks/useDropdownOptions";
import { SrvProceedingFormik } from "@/pages/clients/client/components/tabs/debt-settlement-tab/tabs/srv-proceeding-tab/SrvProceedingTab.types";
import { useTranslation } from "@/translations";

interface Props {
  formik: SrvProceedingFormik;
}

export function ApplicationSection({ formik }: Props) {
  const { t } = useTranslation();
  const { srvCounselingTypes } = useDropdownOptions();

  return (
    <Stack gap={3}>
      <Typography variant="h5">{t("clients.client.debtSettlement.srvProceeding.sections.application")}</Typography>
      <Grid container rowSpacing={2} columnSpacing={2}>
        <Grid size={6}>
          <FormikDatePicker
            formik={formik}
            path="applicationDate"
            label={t("clients.client.debtSettlement.srvProceeding.fields.applicationDate")}
          />
        </Grid>
        <Grid size={6}>
          <FormikAutocomplete
            formik={formik}
            path="counselingType"
            label={t("clients.client.debtSettlement.srvProceeding.fields.counselingType")}
            options={srvCounselingTypes}
          />
        </Grid>
      </Grid>
    </Stack>
  );
}
